import { NgModule } from '@angular/core';
import { L10nTranslationModule } from 'angular-l10n';

@NgModule({
  imports: [L10nTranslationModule],
  exports: [L10nTranslationModule],
})
export class TranslationModule {}
